export default "/kiban/_next/static/images/jpca2018-20ac209e80712b979e5d1a11e4aa214d.png";